<template>
  
    <div >
      <nmsdashboard></nmsdashboard>
      <onedevicepolicy ></onedevicepolicy>
      <!-- <onedevicepolicy v-if="$store.state.currentOrg.org.isPrimaryOrganisation&&$store.state.currentOrg.org.oneDevicePolicy"></onedevicepolicy> -->
      <!-- <twodevicepolicy v-else-if="$store.state.currentOrg.org.isPrimaryOrganisation&&!$store.state.currentOrg.org.oneDevicePolicy"></twodevicepolicy> -->
    </div>

</template>
      <!-- ///////////////////////////////////////////////////////////////////////////////////////////////////////////// -->
<script>
import oneDevicePolicyDashboard from './FNODashboardOneDevice';
import twoDevicePolicyDashboard from './FNODashboardTwoDevice';
import NmsDashboard from '@/components/NmsDashboard.vue';

export default {
  components: {
    onedevicepolicy: oneDevicePolicyDashboard,
    twodevicepolicy: twoDevicePolicyDashboard,
    nmsdashboard: NmsDashboard
  }
};
</script>